export default __webpack_public_path__ + "static/media/sliderThumb.cd920a72.svg";